import React, { FC } from 'react';
import { useHistory } from 'react-router-dom';

import Button from '@mui/material/Button';

interface CreateButtonProps {
  createLink: string;
}

const CreateButton: FC<CreateButtonProps> = (props) => {
  let history = useHistory();

  let { createLink } = props;

  if (!createLink) return null;
  return (
    <Button variant="contained" style={{ width: 80, maxHeight: 50 }} onClick={() => history.push(createLink)}>
      Create
    </Button>
  );
};

export default CreateButton;
